"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollTopFunctionHelper = void 0;
// Scroll up on each new step for mobile devices
const scrollTopFunctionHelper = () => {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
};
exports.scrollTopFunctionHelper = scrollTopFunctionHelper;